import styled from 'styled-components'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

export const ProfileImage = styled.img`
  width: 65px;
  height: 65px;
  border-radius: 100px;
`
export const WrapperHeader = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const DivCentral = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: ${theme.colors.white};
  font-weight: 800;
`

export const Content = styled.div`
  margin-top: 10%;
  @media (min-width: 768px) {
    margin-top: 0;
  }
`

export const M = styled.div`
  margin: 8% 5%;
  @media (min-width: 768px) {
    margin: 4% 10%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`

export const DivInfo = styled.div`
  display: flex;
  gap: 5px;
  color: ${theme.colors.lightGreen};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`

export const DivName = styled.div`
  img {
    margin-left: 10px;
  }
`
export const ButtonCv = styled.button`
  padding: 12px 32px;
  border-radius: 16px;
  background-color: ${theme.colors.lightGreen};
  color: ${theme.colors.green2};
  display: flex;
  align-items: center;
  gap: 15px;
  font-weight: 700;
`

export const WrapperCv = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 15px 0;
  span {
    font-weight: 700;
    color: ${theme.colors.green3};
  }
`

export const WrapperSections = styled.div`
  a {
    margin: 35px 0;
    display: block;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 5px;
    color: ${theme.colors.gray900};
    justify-content: center;
    font-weight: 700;
  }
`

export const InputEdit = styled.input`
  border-radius: 5px;
  padding: 5px;
  padding-left: 10px;
  border: none;
`

export const BtnEdit = styled.button`
  float: right;
  padding: 10px;
  background-color: ${theme.colors.boldGreen};
  color: ${theme.colors.white};
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 5px;
`

export const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
`

export const DivLi = styled.div`
  display: flex;
  gap: 5px;
`

export const ImgTrash = styled.img`
  margin-left: 10px;
  width: 15px;
  cursor: pointer;
`

export const DivPlus = styled.div`
  display: flex;
  gap: 5px;
  align-items: baseline;
`

export const Wrapper = styled.div`
  margin: 8%;
  h2 {
    color: ${theme.colors.gray700};
    margin-bottom: 20px;
  }
`

export const WrapperImage = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: column;

  a {
    color: ${theme.colors.lightGreen};
    font-weight: ${theme.font.medium};
    text-decoration: none;
    font-size: 14px;
  }
`

export const Card = styled.div`
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  background-color: #fff;
  margin: 4% 10%;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
`

export const TitleCFM = styled.div`
  position: absolute;
  top: -12px;
  left: 20px;
  background-color: ${theme.colors.green4};
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: bold;
`

export const ContentCFM = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
font-size: 14px;
  @media (max-width: 768px) {
    flex-direction: column; 
    gap: 10px;
  }
`

export const Column = styled.div`
  flex: 1;
  min-width: 200px;

  @media (max-width: 768px) {
    min-width: 100%;
  }
`

export const Paragraph = styled.div`
  margin: 8px 0;
  color: #757575;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const Label = styled.span`
  color: ${theme.colors.green2};
  font-weight: bold;
  margin-right: 8px;
`
